import {AesUtil} from './AESUtils'

// 存入local
function insertLocalStorage(key, value){
  if(!value){
    console.error('在localStorage存入数据时，value不能为空')
    return
  }
  let inseartVal = ''
  if(typeof(value) == 'object'){
    inseartVal = JSON.stringify(value)
  }else if(typeof(value) == 'string' || typeof(value) == 'number'){
    inseartVal = value
  }else{
    console.error('存入localStorage的数据，value不能为 Object， String， number以外的类型')
    return
  }
  window.localStorage.setItem(key, AesUtil.getAxiosJSONstr(inseartVal).text)
}

// 查询local
function selectLocalStorage(key) {
  let storage = window.localStorage.getItem(key)
  if(storage != null){
    return AesUtil.getAxiosHeadJSONstr(storage)
  }else{
    return null
  }
}

// 删除local
function deleteLocalStorage(key) {
  let storage = window.localStorage.getItem(key)
  if(storage != null){
    window.localStorage.removeItem(key)
  }
}

// 删除所有LocalStorage
function deleteAllLocalStorage(){
  let localKeys = Object.keys(window.localStorage)
  localKeys.forEach(keyName => {
    deleteLocalStorage(keyName)
  })
}

export const localStorage = {
  $insertLocalStorage: (key, value) => insertLocalStorage(key, value),
  $selectLocalStorage: (key) => selectLocalStorage(key),
  $deleteLocalStorage: (key) => deleteLocalStorage(key),
  $deleteAllLocalStorage: () => deleteAllLocalStorage()
}

export default {
  install: function (Vue) {
    Vue.prototype.$insertLocalStorage = (key, value) => insertLocalStorage(key, value)
    Vue.prototype.$selectLocalStorage = (key) => selectLocalStorage(key)
    Vue.prototype.$deleteLocalStorage = (key) => deleteLocalStorage(key)
    Vue.prototype.$deleteAllLocalStorage = () => deleteAllLocalStorage()
  }
}



// WEBPACK FOOTER //
// ./src/util/localStorageModule.js